















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import CaretDownIcon from '@/app/ui/assets/caret_down_icon.vue'
import CloseLine from '@/app/ui/assets/close_line.vue'
import CheckedIcon from '@/app/ui/assets/check_line.vue'
import ExpandIcon from '@/app/ui/assets/expand_icon.vue'
import TreeList from '../TreeList/index.vue'

export interface ILocation {
  name: string
  isChecked: boolean
  geoAddressId: string
  isParentNotHidden: boolean
  setParentNotHidden: (state: boolean) => void
  isNotHidden: (keyword: string) => boolean
  isDisabled: () => boolean
  getGeoAddressIds: () => Array<number>
  setIsChecked: (state: boolean) => void
  setCheckedNested: (state: boolean) => void
  children: Array<ILocation>
}

/**
  NestedMultiselect

  `placeholder`
  placeholder props accept string that will be show on field when there is no selected data

  `value`
  value accept Array of String which contain the selected value

  `options`
  options props received accept data with type Array of ILocation.
  below is the example of the accepted data
  options = [
    {
      name: string,
      isChecked: boolean,
      disabled: boolean,
      setIsChecked(state: boolean): void {
        this.isChecked = state
      },
      setCheckedNested(state: boolean): void {
        this.isChecked = state
        if (this.children.length !== 0) {
          this.children.forEach(item => {
            if (item.children.length !== 0) {
              item.setCheckedNested(state)
            } else {
              item.isChecked = state
            }
          })
        }
      },
      children: []
    }
  ]

  `disabled`
  this will set the component state if it's enabled or disabled
**/

@Component({
  name: 'NestedMultiSelect',
  components: {
    CaretDownIcon,
    CloseLine,
    CheckedIcon,
    ExpandIcon,
    TreeList,
  },
})
export default class NestedMultiselect extends Vue {
  @Prop({ type: String }) placeholder!: string
  @Prop({ type: Array, default: () => [] }) value!: Array<number>
  @Prop({ type: Array, default: () => [] }) mainOptions!: Array<ILocation>
  @Prop({ type: Boolean, default: false }) disabled!: boolean

  isDropdownVisible = false
  selectedValues: Array<string> = []
  optionList: Array<ILocation> = []
  keyword = ''

  get options(): Array<ILocation> {
    return this.onFilterOption(this.mainOptions, this.keyword)
  }

  get treeListMeta(): string {
    const meta = {
      keyword: this.keyword
    }
    return JSON.stringify(meta)
  }

  private getName(data: Array<ILocation>): Array<string> {
    let nameList: Array<string> = []

    data.forEach(item => {
      if (item.isChecked && !item.isDisabled()) {
        nameList.push(item.name)
      } else {
        nameList.push(...this.getName(item.children))
      }
    })

    return nameList
  }

  private onFilterOption(
    list: Array<ILocation>,
    keyword: string
  ): Array<ILocation> {
    if (keyword) {
      const find = (item: ILocation) =>
        item.name.toUpperCase().includes(keyword.toUpperCase()) ||
        (item.children && item.children.some(find))

      return list.filter(find)
    }

    return list
  }

  private getSelectedValues(data: Array<ILocation>): Array<number> {
    let idList: Array<number> = []

    data.forEach(item => {
      if (item.isChecked && item.geoAddressId && !item.isDisabled()) {
        idList.push(Number(item.geoAddressId))
      } else {
        idList.push(...this.getSelectedValues(item.children))
      }
    })

    return idList
  }
  
  private onClickField(): void {
    if (!this.disabled) {
      this.isDropdownVisible = !this.isDropdownVisible
    }
  }

  private onClickOutside(): void {
    this.keyword = ''
    this.isDropdownVisible = false
  }

  private onRemoveItem(list: Array<ILocation>, name: string): void {
    if (!this.disabled) {
      list.forEach(item => {
        if (item.name === name) {
          item.setCheckedNested(false)
        } else {
          this.onRemoveItem(item.children, name)
        }
      })
    }
  }

  @Watch('mainOptions', { deep: true })
  onMainValueChange(): void {
    if (this.mainOptions.length !== 0) {
      this.selectedValues = [...this.getName(this.mainOptions)]
    }

    this.$emit('onChange', [
      ...new Set([...this.getSelectedValues(this.mainOptions)]),
    ])
  }
}
